import {useState, useCallback} from 'react';
import Box from '@mui/material/Box'
import ImageList from '@mui/material/ImageList';
import {ImageListItem} from '@mui/material';
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import HeaderHome from "../components/HeaderHome";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import {useFetchFlowers} from '../hooks/useFetchFlowers'
import {useFetchHistory} from '../hooks/useFetchHistory'
import {useFetchStation} from '../hooks/useFetchStation'
import {useFetchFacility} from '../hooks/useFetchFacility'
import {useFetchHome} from '../hooks/useFetchHome'
import {getLink} from "../utils/UrlUtil.js";
import {useSharedLang} from '../hooks/useSharedLang.js';
import {LANGS } from "../components/constants.js";
import Loading from "../components/Loading.js";

const Home = (props) => {
  const { t } = useTranslation();

  const {flowerList, isLoadingFlowers} = useFetchFlowers();
  const {historyList, isLoadingHistory} = useFetchHistory();
  const {stationList, isLoadingStation} = useFetchStation();
  const {facilityList, isLoadingFacility} = useFetchFacility();
  const {homeList, isLoadingHome} = useFetchHome();
  //const {newsList, isLoadingNews} = useRssNews();
  const { sharedLang } = useSharedLang();
  const menuImages = [
    ...(sharedLang === LANGS.JAPANESE ? [{
      img: '/assets/images/others/menu_audio.svg',
      title: t("home.menu_audio"),
      to:"/audio-guide" 
    }]: []),
    {
      img: '/assets/images/others/menu_nature.svg',
      title: t("home.menu_nature"),
      to:"/nature" 
    },
    {
      img: '/assets/images/others/menu_station.svg?20250629',
      title: t("home.menu_station"),
      to:"/station" 
    },
    {
      img: '/assets/images/others/menu_history.svg',
      title: t("home.menu_history"),
      to:"/history" 
    },
    {
      img: '/assets/images/others/menu_barrier.svg',
      title: t("home.menu_barrier"),
      to:"/barrier-free" 
    },
    {
      img: '/assets/images/others/menu_facility.svg',
      title: t("home.menu_facility"),
      to:"/facility" 
    }
  ];

  const slickSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    adaptiveHeight:true,
    arrows: true
  };

  const slickData = () => {
        let ret = [];
        if(homeList.slick && homeList.slick.length > 0){
          let Data = flowerList.concat(historyList).concat(stationList).concat(facilityList);
          Data.forEach(element => {
              let link = getLink(element);
              if(homeList.slick.includes(link)){
                let index = Object.keys(homeList.slick).find((key) => homeList.slick[key] === link)
                element.slickKey = index;
                ret.push(element);
              }
          });
          ret.sort((a, b) => a.slickKey - b.slickKey);
        }
        return ret;
    };

  if (isLoadingFlowers || isLoadingHistory || isLoadingStation || isLoadingFacility || isLoadingHome) {
    // (async () => {
    //   const sleep = ms => new Promise(r => setTimeout(r, ms));
    //   await sleep(3000);
    // })()
    return (<Loading></Loading>);
  }
  // if(!isLoadingNews){
  //   console.log(newsList);
  // }
  return (
      <Box className="home">
          <HeaderHome></HeaderHome>

          <div className="category-menu">
            <div className="subtitle">{t("home.subtitle_to_map")}</div>
            <ImageList sx={{ width: 360 }} variant="masonry" cols={3} gap={5}>
              {menuImages.map((item) => (
                <Link to={item.to}>
                <ImageListItem key={item.img}>
                <div className="buttonSquare">
                  <img
                    srcSet={`${item.img}`}
                    src={`${item.img}`}
                    alt={item.title}
                    loading="lazy"
                  />
                  <p>{item.title}</p>
                </div>
                </ImageListItem>
                </Link>
              ))}
            </ImageList>
          </div>    

          <div className="slick-wrap">
            <div className="subtitle">{t("home.subtitle_enjoy")}</div>
            <Slider {...slickSettings}>
            {
              slickData().map((element, index) => 
                <Link to={getLink(element)}>
                <Box className="img-carousel-wrap">
                  <img className="img-carousel" src={"/assets/images/descriptions/" + element.path} />
                  <p>{sharedLang === LANGS.ENGLISH?element.nameEnglish:element.name}</p>
                </Box>
                </Link>
              )
            }
            </Slider>
          </div>


          <div className="btm-info">
          <ImageList variant="woven" cols={1}>
          <Link to="https://fng.or.jp/koukyo/category/%e3%81%8a%e7%9f%a5%e3%82%89%e3%81%9b/" target="_blank">
              <ImageListItem>
                <img
                  srcSet={`/assets/images/others/${t("home.information_img")}`}
                  src={`/assets/images/others/${t("home.information_img")}`}
                  alt={`${t("home.information")}`}
                  loading="lazy"
                />
              </ImageListItem>
              </Link>
          </ImageList>
          </div>
          <div className="note">
          {t("home.note1")}<br/>
          {t("home.note2")}
          </div>     

          <div className="sns-wrap">
            <div className="subtitle">{t("home.subtitle_news")}</div>
            <p>{t("home.information_note")}</p>
            <div className="img-wap">
              <Link to="https://www.instagram.com/kokyogaien_info/" target="_blank">
                <img src="/assets/images/others/icon_insta_gr.svg" />
              </Link>
              <Link to="https://x.com/KG_info_kyokai" target="_blank">
                <img src="/assets/images/others/icon_x_gr.svg" />
              </Link>
            </div>
          </div>

      </Box>  
  )
}
export default Home